import Vue from 'vue'
import Nprogress from 'nprogress'
import api from '../../../api/apibackend'

import {
    SET_CASHIERS,
    FETCH_START,
    FETCH_END
} from './mutations.type'

import {
    GET_CASHIERS,
    CREATE_CASHIER,
    UPDATE_CASHIER,
    DELETE_CASHIER
} from './actions.type'

const state = {
    cashiers: [],
    loadingCashiers: false
}

const getters = {
    cashiers: state => state.cashiers,
    loadingCashiers: state => state.loadingCashiers
}

const mutations = {
    [SET_CASHIERS](state, cashiers) {
        state.cashiers = cashiers
    },
    [FETCH_START](state) {
        Nprogress.start()
        state.loadingCashiers = true
    },
    [FETCH_END](state) {
        state.loadingCashiers = false
        Nprogress.done()
    }
}

const actions = {
    async [GET_CASHIERS]({
        dispatch,
        commit,
        rootGetters
    }) {
        try {
            commit(FETCH_START)
            if (!rootGetters.store) {
                dispatch(GET_STORE_USER_AUTH)
            }
            const res = await api.get(`store/${rootGetters.store.id}/cashier`)
            commit(SET_CASHIERS, res.data)
            commit(FETCH_END)
            return res.data
        } catch (err) {
            commit(FETCH_END)
            Vue.notify({
                group: 'loggedIn',
                type: 'error',
                text: err.message
            })
        }
    },
    async [CREATE_CASHIER]({
        commit,
        dispatch
    }, userData) {
        try {
            commit(FETCH_START)
            const res = await api.post('admin/cashier', userData)
            dispatch(GET_CASHIERS)
            commit(FETCH_END)
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: '✔️ Cajero creado exitosamente'
            })
        } catch (err) {
            commit(FETCH_END)
            Vue.notify({
                group: 'loggedIn',
                type: 'error',
                text: '❌ Ha ocurrido un error al crear el cajero'
            })
        }
    },
    async [UPDATE_CASHIER]({
        commit,
        dispatch
    }, userData) {
        try {
            commit(FETCH_START)
            const res = await api.patch(`admin/${userData.id}`, userData)
            dispatch(GET_CASHIERS)
            commit(FETCH_END)
            Vue.notify({
                group: 'loggedIn',
                type: 'success',
                text: '✔️ Cajero actualizado exitosamente'
            })
        } catch (err) {
            commit(FETCH_END)
            Vue.notify({
                group: 'loggedIn',
                type: 'error',
                text: '❌ Ha ocurrido un error al actualizar el cajero'
            })
        }
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}